module.exports = __webpack_public_path__ + "media/feedback-1-b47b8daf4efc9807a7cec7ab97458503.png";